import { render } from "./WordChunk.vue?vue&type=template&id=29385096&scoped=true"
import script from "./WordChunk.vue?vue&type=script&lang=js"
export * from "./WordChunk.vue?vue&type=script&lang=js"

import "./WordChunk.vue?vue&type=style&index=0&id=29385096&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29385096"]])

export default __exports__